import $ from 'jquery';

export default class Footer {
	constructor() {
		this.languageBtn = $('.footer__language-btn');
		this.dropdown = $('.footer__language-btn-dropdown');
		this.languageList = $('.language-list');
		this.languageListClose = $('.language-list__close');
	}

	init() {
		this.languageBtn.on('click', event => {
			event.preventDefault();

			this.dropdown.toggleClass('footer__language-btn-dropdown_open');
			this.languageList.toggleClass('language-list_open');

			$('html, body').animate({
				scrollTop: this.languageList.offset().top
			}, 400);
		});

		this.languageListClose.on('click', event => {
			event.preventDefault();

			this.dropdown.removeClass('footer__language-btn-dropdown_open');
			this.languageList.removeClass('language-list_open');
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/footer/index.js